const FlowText = () => {
  return (
    <div className="relative w-full h-fit text-white">
      <div className="relative w-full h-fit mx-auto flex items-center pt-2">
        <div className="relative w-fit min-w-[190px] h-fit hidden lg:block border-r mr-5">
          <p className="">
            <span>실시간&nbsp;견적문의&nbsp;현황</span>
          </p>
        </div>
        <div className="relative w-fit h-fit flow-text">
          <ul className="flex gap-5 flow-wrap text-base">
            <li>
              <span className="">김00</span> (누수탐지)
            </li>
            <li>
              <span className="">이00</span>(누수공사)
            </li>
            <li>
              <span className="">오00</span>(누수공사)
            </li>
            <li>
              <span className="">신00</span>(건물누수)
            </li>
            <li>
              <span className="">임00</span>(누수탐지)
            </li>
            <li>
              <span className="">김00</span> (누수탐지)
            </li>
            <li>
              <span className="">이00</span> (누수탐지)
            </li>
            <li>
              <span className="">오00</span> (누수공사)
            </li>
            <li>
              <span className="">신00</span> (누수탐지)
            </li>
            <li>
              <span className="">임00</span> (건물누수)
            </li>
          </ul>
          <ul className="flex gap-5 flow-wrap text-base">
            <li>
              <span className="">김00</span> (누수탐지)
            </li>
            <li>
              <span className="">이00</span>(누수공사)
            </li>
            <li>
              <span className="">오00</span>(누수공사)
            </li>
            <li>
              <span className="">신00</span>(건물누수)
            </li>
            <li>
              <span className="">임00</span>(누수탐지)
            </li>
            <li>
              <span className="">김00</span> (누수탐지)
            </li>
            <li>
              <span className="">이00</span> (누수탐지)
            </li>
            <li>
              <span className="">오00</span> (누수공사)
            </li>
            <li>
              <span className="">신00</span> (누수탐지)
            </li>
            <li>
              <span className="">임00</span> (건물누수)
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default FlowText;
